export default {
    name: "Evening vs night",
    data:
    {
        "id": "62d3db3e-7515-4612-b9e0-956be2ee74a9",
        "title": "Evening vs night",
        "type": "Composite",
        "config": {
            "operator": "Subtract",
            "combine_on": "gasday",
            "left": {
                "id": "425f4a31-682c-43c2-9901-733728459dc4",
                "title": "Evening Price",
                "type": "Composite",
                "config": {
                    "operator": "Filter",
                    "combine_on": "date",
                    "left": {
                        "id": "9883cb3f-c1df-41e7-aa35-5c100c492437",
                        "title": "",
                        "type": "Single",
                        "config": {
                            "type_id": "vwap",
                            "hub_id": 21,
                            "product_id": "49",
                            "hour": "18",
                            "start_date": "2025-01-28",
                            "end_date": "2025-08-27"
                        }
                    },
                    "right": {
                        "id": "fc4f2a66-6fe3-426a-82c2-8d5faedb4e1f",
                        "title": "TTF is balanced",
                        "type": "Composite",
                        "config": {
                            "operator": "LessThan",
                            "combine_on": "date",
                            "left": {
                                "id": "c91c40dd-0480-4004-add5-4c1fe04f018e",
                                "title": "",
                                "type": "Formatter",
                                "config": {
                                    "type_id": "classify",
                                    "lower": -5,
                                    "upper": 5,
                                    "child": {
                                        "id": "c88d33a7-7ff5-470f-a2a9-2a56f2046d91",
                                        "title": "",
                                        "type": "Single",
                                        "config": {
                                            "type_id": "linepack",
                                            "hub_id": 21,
                                            "hour": "18",
                                            "start_date": "2025-01-28",
                                            "end_date": "2025-08-27"
                                        }
                                    },
                                    "start_date": "2025-01-28",
                                    "end_date": "2025-08-27"
                                }
                            },
                            "right": {
                                "id": "d53af4ea-c5fa-4ffa-99e8-a6a5b0a9a94e",
                                "title": "",
                                "type": "Single",
                                "config": {
                                    "type_id": "constant_value",
                                    "value": 1,
                                    "start_date": "2025-01-28",
                                    "end_date": "2025-08-27"
                                }
                            }
                        }
                    }
                }
            },
            "right": {
                "id": "6f3747e4-0945-47d8-af91-8266b03366f6",
                "title": "",
                "type": "Single",
                "config": {
                    "type_id": "vwap",
                    "hub_id": 21,
                    "product_id": "49",
                    "hour": "2",
                    "start_date": "2025-01-28",
                    "end_date": "2025-08-27"
                }
            }
        }
    }
}